<template>
  <transition name="fade">
    <div
        class="popup tips-popup"
        v-if="popupState.tips"
    >
      <div class="popup-mask fade-in" @click="hidePopup()"></div>
      <div class="popup-main limit-px">
        <a
            href="javascript:void(0);"
            class="popup-main-close"
            @click="hidePopup()"
        ></a>
        <p class="tips">{{ popupState.tips }}</p>
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import popupHook from '@/hooks/popupHook';
const { popupState, hidePopup } = popupHook();
</script>
